import EventEmitter from 'eventemitter3';

export class EventUtils {
    private resizeEndTimeout: any;
    private windowResizeStopEmitter: any;

    constructor(){
        this.windowResizeStopEmitter = new EventEmitter();

        this.handleWindowResize();
    }

    public registerResizeStartCallback(callback){
        this.windowResizeStopEmitter.addListener("resizestart", callback);
    }

    public unregisterResizeStartCallback(callback){
        this.windowResizeStopEmitter.removeListener("resizestart", callback);
    }

    public registerResizeEndCallback(callback){
        this.windowResizeStopEmitter.addListener("resizestop", callback);
    }

    public unregisterResizeEndCallback(callback){
        this.windowResizeStopEmitter.removeListener("resizestop", callback);
    }

    private handleWindowResize(){
        window.addEventListener("resize", () => {
            clearTimeout(this.resizeEndTimeout);

            this.windowResizeStopEmitter.emit("resizestart");

            this.resizeEndTimeout = setTimeout(() => {
                this.windowResizeStopEmitter.emit("resizestop");
            }, 200)
        });
    }

    public handleContainerScroll(event){
        const element = event.currentTarget;
        
        const delta = event.wheelDelta || -event.detail;

        const elementHeight = parseFloat(window.getComputedStyle(element).height);
        const bottomOverflow = element.scrollTop + elementHeight - element.scrollHeight >= 0;
        const topOverflow = element.scrollTop <= 0;

        if ((delta < 0 && bottomOverflow) || (delta > 0 && topOverflow)) {
            const xDelta = event.deltaX || event.wheelDeltaX;
            const yDelta = event.deltaY || event.wheelDeltaY;

            if(xDelta != undefined && yDelta != undefined){
                if(Math.abs(xDelta) > Math.abs(yDelta)){
                    //If it is a predominately horizontal scroll don't prevent default
                    return;
                }
            }
            
            event.preventDefault();
            return;
        }
    }

    public handleDragScroll(element: Element){
        let isMouseDown = false, curYPos = 0, curXPos = 0;

        if((element as any).hasDragEvents){
            return;
        }

        const handleMouseMove = (e) => {
            if(isMouseDown){
                const isDominantlyHorizontalMove = Math.abs(curXPos - e.pageX) >= Math.abs(curYPos - e.pageY);

                if(isDominantlyHorizontalMove){
                    element.scrollLeft += 0.1*(curXPos - e.pageX);
                }
                else {
                    element.scrollTop += 0.1*(curYPos - e.pageY); 
                }
            }
        };

        const handleMouseUpOrLeave = () => {
            isMouseDown = false
            element.removeEventListener("mousemove", handleMouseMove);
        };

        const handleMouseDown = (e: MouseEvent) => {
            isMouseDown = true;
            curYPos = e.pageY;
            curXPos = e.pageX;
            element.addEventListener("mousemove", handleMouseMove);
        }
        
        element.addEventListener("mousedown", handleMouseDown);
        element.addEventListener("mouseup", handleMouseUpOrLeave);
        element.addEventListener("mouseleave", handleMouseUpOrLeave);

        (element as any).hasDragEvents = true;
        (element as any).mousedownHandler = handleMouseDown;
        (element as any).mouseupleaveHandler = handleMouseUpOrLeave;
    }

    public removeDragScrollEvents(element){
        if(!element || !element.hasDragEvents){ return; }

        if(element.mousedownHandler){
            element.removeEventListener("mousedown", element.mousedownHandler);
        }

        if(element.mouseupleaveHandler){
            element.removeEventListener("mouseup", element.mouseupleaveHandler);
            element.removeEventListener("mouseleave", element.mouseupleaveHandler);
        }
        
        element.hasDragEvents = false;
        delete element.hasDragEvents;
    }
}

export default new EventUtils();